import React, { useState, useMemo } from "react";

import {
  Button,
  Flex,
  Input,
  message,
  Space,
  Switch,
  Table,
  Typography,
} from "antd";

import { useNavigate } from "react-router-dom";
import { EditFilled } from "@ant-design/icons";
import ManufacturerResponse from "../../payload/response/ManufacturerResponse";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getManufacturers,
  updateManufacturerStatus,
} from "../../services/manufacturerService";

const { Title } = Typography;
export default function Manufacturers() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  const { data, isPending, isFetching } = useQuery({
    queryKey: ["manufacturers"],
    queryFn: getManufacturers,
  });

  const filteredData = useMemo(() => {
    if (!data?.list) return [];
    const normalizeText = (text: string) => {
      return text
        .toLowerCase()
        .replace(/ç/g, "c")
        .replace(/ğ/g, "g")
        .replace(/ı/g, "i")
        .replace(/ö/g, "o")
        .replace(/ş/g, "s")
        .replace(/ü/g, "u");
    };
    const searchNormalized = normalizeText(searchText);
    return data.list.filter((item) =>
      normalizeText(item.name).includes(searchNormalized)
    );
  }, [data?.list, searchText]);

  const mutation = useMutation({
    mutationFn: updateManufacturerStatus,
    onSuccess: () => {
      message.success("Üretici firma başarıyla güncellendi");
      queryClient.invalidateQueries({
        queryKey: ["manufacturers"],
      });
    },
    onError: () => {
      message.error("Üretici firma güncellenirken bir hata oluştu");
    },
  });

  return (
    <>
      <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
        <Title level={2}>Üretici Firmalar</Title>
        <Button
          onClick={() => {
            navigate("/admin/manufacturers/add");
          }}
          type="primary"
        >
          Yeni Üretici Ekle
        </Button>
      </Flex>
      <Input
        placeholder="Üretici adına göre arama yapınız..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16 }}
        allowClear
      />
      <Table<ManufacturerResponse>
        loading={isPending || isFetching}
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ["50", "100", "200"],
        }}
        columns={[
          {
            title: "Üretici Adı",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "Durum",
            dataIndex: "isActive",
            key: "isActive",
            render: (text, record) => {
              return (
                <Space>
                  <Switch
                    checkedChildren="Aktif"
                    unCheckedChildren="Pasif"
                    onChange={(value) => {
                      mutation.mutate(record.id);
                    }}
                    checked={record.isActive}
                  />
                </Space>
              );
            },
          },
          {
            title: "İşlem",
            dataIndex: "action",
            key: "action",
            width: "30%",
            render: (text, record) => {
              return (
                <span>
                  <Button
                    onClick={() => {
                      navigate(`/admin/manufacturers/edit/${record.id}`);
                    }}
                    type="primary"
                    style={{ marginLeft: 10 }}
                  >
                    <EditFilled />
                  </Button>
                </span>
              );
            },
          },
        ]}
        dataSource={filteredData?.map?.((item) => ({
          ...item,
          key: item.id,
        }))}
      />
    </>
  );
}
